import { Flight, MobileSector, MobileSectorVm, NewFlightItemVm } from '@app/entities/flight-results';
import { Room } from '@shared/base-search-bar/entities/room.entities';
import { PassengerArrangement, PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { 
  AZUL_AIR_CODE, 
  CLIC_AIR_CODE, 
  GOL_AIR_CODE, 
  SATENA_AIR_CODE } from '@shared/luggage/constants/airline-code.constants';
import { FlightClassNumericTypes, FlightClassOrder, FlightClassTypes } from '@shared/base-search-bar/entities/flight-class-types';

export const MILLISECONDS_IN_ONE_MINUTE = 60000;


export const flightItemMapper = 
  (sector: MobileSector, OptionId: number, TotalResidualValue: number = 0, HasPrivateFare: boolean = false): NewFlightItemVm => { 
    const flightsLength = sector.Flights.length;
    const sectorItem = { ...sector, Flights: sectorFlightsMapper(sector.Flights) };
    return {
      ...sectorItem,
      DepartureAirport: sectorItem.Flights[0].DepartureAirport,
      ArrivalAirport: sectorItem.Flights[flightsLength - 1].ArrivalAirport,
      AirlineCode: sectorItem.Flights[0].AirlineCode,
      AirlineName: sectorItem.Flights[0].AirlineName,
      DepartureDate: sectorItem.Flights[0].DepartureDate,
      ArrivalDate: sectorItem.Flights[flightsLength - 1].ArrivalDate,
      OptionId,
      TotalResidualValue,
      FareBasis: sectorItem.Flights[0].FareBasis,
      FareFamilies: sectorItem.Flights[0].FareFamilies,
      HasPrivateFare
    }
  }

export function sectorFlightsMapper(flights: Flight[] = []): Flight[] {
  const maxFlights = flights.length - 1;
  return flights.map((_flight: Flight, flightIndex: number) => {
    const flight = flightEntity(_flight);
    if (flightIndex < maxFlights) {
      const nextFlightIndex = flightIndex + 1;
      const nextFlight = flights[nextFlightIndex];
      return {
        ...flight,
        IsConnectionInDifferentAirport: flight.ArrivalAirport !== nextFlight.DepartureAirport
      };
    } else return flight;
  });
}

export function flightsCabinsMapper(routes: MobileSectorVm[]): string[] {
  return routes.map(r => r.Flights.reduce((arr, f) => [...arr, f.Cabin], [])).reduce((arr, r) => [...arr, r], []);
}

export function passengersQuantityMapper(passengers: PassengerArrangement[], type: PassengerType): number {
  return passengers.filter(x => x.id === type).reduce((acc, x) => x.quantity + acc, 0);
}

export function guestsQuantityMapper(rooms: Room[], type: PassengerType): number {
  if (type === PassengerType.ADULTS) return rooms.reduce((acc, r) => r.ADULTS + acc, 0);
  if (type === PassengerType.CHILDREN) return rooms.reduce((acc, r) => r.CHILDREN + acc, 0);
  return 0;
}

export function isGolAir(code: string): boolean {
  return code === GOL_AIR_CODE;
}

export function isAzulAir(code: string): boolean {
  return code === AZUL_AIR_CODE;
}

export function isClicAir(code: string): boolean {
  return code === CLIC_AIR_CODE;
}

export function isSatenaAir(code: string): boolean {
  return code === SATENA_AIR_CODE;
}

export function withFareBasic(code: string): boolean {
  return isAzulAir(code) || isGolAir(code);
}

function flightEntity(_flight: Flight): Flight {
  return withFareBasic(_flight.AirlineCode) && _flight.FareBasis ? {
    ..._flight,
    FareFamilies: _flight.FareBasis
  } : _flight;
}

export function cabinTypeNameMapper(cabinType: string): string {
  if (cabinType) {
    switch (cabinType) {
      case FlightClassNumericTypes.BUSINESS:
        return FlightClassTypes.BUSINESS;
      case FlightClassNumericTypes.ECONOMY:
        return FlightClassTypes.ECONOMY;
      case FlightClassNumericTypes.FIRST:
        return FlightClassTypes.FIRST;
      case FlightClassNumericTypes.PREMIUMECONOMY:
        return FlightClassTypes.PREMIUMECONOMY;
      default:
        return FlightClassTypes.ECONOMY;
    }
  } else return null;
}

export function cabinOrder(cabinType: string): string {
  if (cabinType) {
    switch (cabinType) {
      case FlightClassNumericTypes.BUSINESS:
        return FlightClassOrder.BUSINESS;
      case FlightClassNumericTypes.ECONOMY:
        return FlightClassOrder.ECONOMY;
      case FlightClassNumericTypes.FIRST:
        return FlightClassOrder.FIRST;
      case FlightClassNumericTypes.PREMIUMECONOMY:
        return FlightClassOrder.PREMIUMECONOMY;
      default:
        return FlightClassOrder.ECONOMY;
    }
  } else {
    return null;
  }
}
